import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsProvider } from "../../@hooks"


export default function UserSettingsProvidersTabButton() {

    const { handleSetProviderFormData } = useUserSettingsProvider()

    return <AppToolbarCreateButton
        label="Define Providers Color"
        onClick={handleSetProviderFormData}
    />
}